var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.function.name", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.function.name"), require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Function, global.react, global.propTypes, global.classnames);
    global.ProgramCredits = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Function, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  var renderRow = function renderRow(index, label, content, isPresse, leftClass, rightClass) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "row program-credits__list-item",
      key: "row-".concat(index)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column ".concat(leftClass)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "program-credits__label"
    }, label, isPresse ? ':' : ' :')), /*#__PURE__*/_react.default.createElement("ul", {
      className: "column ".concat(rightClass, " program-credits__list")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "program-credits__content"
    }, content.constructor.name === 'Array' ? content.map(function (name, idx) {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "program-credits__list-item",
        key: "name-".concat(idx)
      }, name);
    }) : /*#__PURE__*/_react.default.createElement("li", {
      className: "program-credits__list-item"
    }, content))));
  };

  var ProgramCredits = function ProgramCredits(_ref) {
    var columnLeft = _ref.columnLeft,
        columnRight = _ref.columnRight,
        className = _ref.className;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('program-credits', 'row small-up-1', 'medium-up-2', className)
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "columns column-block program-credits__list"
    }, columnLeft.map(function (_ref2, index) {
      var label = _ref2.label,
          content = _ref2.content;
      return renderRow(index, label, content, className === 'presse', 'small-5 medium-5 large-5 xlarge-4', 'small-6 medium-6 large-6 xlarge-7');
    })), /*#__PURE__*/_react.default.createElement("ul", {
      className: "columns column-block program-credits__list"
    }, columnRight.map(function (_ref3, index) {
      var label = _ref3.label,
          content = _ref3.content;
      return renderRow(index, label, content, className === 'presse', 'small-5 medium-4 large-4 xlarge-3', 'small-6 medium-8 large-8 xlarge-9');
    })));
  };

  ProgramCredits.propTypes = {
    columnLeft: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]).isRequired
    })),
    columnRight: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]).isRequired
    })),
    className: _propTypes.default.string
  };
  ProgramCredits.defaultProps = {
    columnLeft: [],
    columnRight: [],
    className: ''
  };
  var _default = ProgramCredits;
  _exports.default = _default;
});